import styles from './style.module.scss';
import { motion } from 'framer-motion';
import { links, footerLinks } from './data';
import { perspective, slideIn } from "./anim";
import { useEffect, useState } from 'react';
import Magnetic from '../../../Projects/Test/common/Magnetic';
export const metadata = {
    title: "Protfolo Navbar",
    
  };

export default function Index() {

    useEffect(() => {
        const handlePathnameChange = () => setPathname(window.location.pathname);
        handlePathnameChange(); // Set initial pathname
        window.addEventListener('popstate', handlePathnameChange);
        return () => {
          window.removeEventListener('popstate', handlePathnameChange);
        };
      }, []);
    
      const [pathname, setPathname] = useState(window.location.pathname);
      const [selectedIndicator, setSelectedIndicator] = useState(pathname);


  return (
    <div className={styles.nav} onMouseLeave={() => setSelectedIndicator(pathname)}>
       <div className={styles.body}>

     
        {
            links.map( (link, i) => {
                const { title, href } = link;
                const isActive = selectedIndicator === href;

                return (
                    <div className={styles.el}>
                        <div key={`b_${i}`} className={`${styles.linkContainer} ${isActive ? styles.activeLink : ''}`} >
                        <motion.div
                          href={href}
                          custom={i}
                          variants={perspective}
                          initial="initial"
                          animate="enter"
                          exit="exit"
                        >
                            <a href={href} isActive={isActive}
              setSelectedIndicator={setSelectedIndicator}>
                                {title}
                            </a>
                            <div className={styles.indicator}></div>
                        </motion.div>
                    </div>
                    </div>
                )
            })
        }
       </div>
       <motion.div className={styles.footer}>
            {
                footerLinks.map( (link, i) => {
                    const { title, href } = link;
                    return (
                        <motion.a 
                            variants={slideIn}
                            custom={i} 
                            initial="initial"
                            animate="enter"
                            exit="exit"
                            key={`f_${i}`}
                        >
                           <Magnetic>
                            <p><a href={href}> {title}</a></p>
                            
                            </Magnetic>
                        </motion.a>
                    )
                })
            }
       </motion.div>
    </div>
  )
}
